export default class ViewMessage {
  #type;
  #header;
  #body;

  get type() {
    return this.#type;
  }

  get header() {
    return this.#header;
  }

  get body() {
    return this.#body;
  }

  constructor({ type, header, body }) {
    this.#type = type;
    this.#header = header;
    this.#body = body;
  }

  display($container) {
    if (!$container) {
      $container = $("body");
    }

    const $wrap = $container.find(".view-msg-wrap");
    let $elements = $wrap.find(`.msg-${this.#type}`);

    // Create a new elemnt if the original was dismissed
    if ($elements.length == 0) {
      $elements = this.#getMarkup();
      $wrap.append($elements);
    }

    $elements.empty();

    const $header = $("<span class='text-semibold' />");
    $header.html(this.#header);

    // Drop duplicated full stops at the end of the body
    if (this.#body.slice(-2) === "..") {
      this.#body = this.#body.slice(0, -1);
    }

    const $body = $("<p />");
    $body.html(this.#body);

    if ($elements.hasClass("alert-dismissable")) {
      $elements.append($("<button class='close' data-dismiss='alert'>&times;</button>"));
    }

    $elements.append($header)
      .append($body);

    $elements.fadeIn();
  }

  #getMarkup() {
    return $(`<div role="alert" class="msg-${this.#type} alert alert-danger alert-dismissable"></div>`);
  }
}
